import { cn } from '@/lib/utils';

interface SkipLinkProps {
  targetId?: string;
  label?: string;
  className?: string;
}

/**
 * Skip link component for keyboard users to bypass navigation.
 * Visually hidden until focused.
 *
 * @example
 * <SkipLink /> // Uses defaults: targets #main-content
 * <SkipLink targetId="pricing-table" label="Skip to pricing" />
 */
export default function SkipLink({
  targetId = 'main-content',
  label = 'Skip to main content',
  className
}: SkipLinkProps) {
  return (
    <a
      href={`#${targetId}`}
      className={cn(
        'sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-4 focus:left-4',
        'focus:bg-white focus:text-primary-600 focus:px-4 focus:py-2 focus:rounded-lg',
        'focus:shadow-lg focus:font-medium focus:outline-none focus:ring-2 focus:ring-primary-500',
        'dark:focus:bg-gray-800 dark:focus:text-primary-400',
        className
      )}
    >
      {label}
    </a>
  );
}
